<template>
	<field-wrapper v-bind="wrapper" @hook:mounted="watchField">
		<input ref="field" v-bind="bind" v-model="model" />
	</field-wrapper>
</template>

<script>
import FieldWrapper from '@/components/shared/FieldWrapper'
import field from '@/mixins/field'

export default {
	name: 'field-input',
	mixins: [field],
	components: {
		FieldWrapper
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
input {
	@extend %field;
}
</style>
